"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Pilot() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="4778" id="initiate-a-pilot" className="text-foreground relative overflow-hidden py-32 md:py-48 lg:py-[200px] px-6 md:px-12 bg-background">
      {/* Flat CSS graph-paper grid pattern */}
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: `
            linear-gradient(to right, rgba(255, 255, 255, 0.05) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
          `,
      backgroundSize: "32px 32px"
    }} />

      {/* Top border line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-border/60" />

      <div className="relative z-10 max-w-7xl mx-auto p-8 md:p-12">
        {/* Corner accent marks */}
        <div className="absolute top-0 left-0 size-3 border-t border-l border-[#FFDB99] pointer-events-none" />
        <div className="absolute top-0 right-0 size-3 border-t border-r border-[#FFDB99] pointer-events-none" />
        <div className="absolute bottom-0 left-0 size-3 border-b border-l border-[#FFDB99] pointer-events-none" />
        <div className="absolute bottom-0 right-0 size-3 border-b border-r border-[#FFDB99] pointer-events-none" />

        <div className="flex flex-col items-center text-center">
          <span className="text-[11px] font-medium uppercase font-default transition-all duration-1000 ease-out" style={{
          color: "var(--primary)",
          letterSpacing: "0.22em",
          opacity: headingVisible ? 1 : 0,
          transform: headingVisible ? "translateY(0)" : "translateY(20px)"
        }}>
            Start a Conversation
          </span>

          <h2 ref={headingRef} className="mt-4 font-default font-light leading-[0.95] tracking-tight text-foreground transition-all duration-1000 ease-out" style={{
          fontSize: "clamp(3rem, 10vw, 8.75rem)",
          opacity: headingVisible ? 1 : 0,
          transform: headingVisible ? "translateY(0)" : "translateY(40px)"
        }}>
            Run a Setura pilot with one class.
          </h2>

          <p ref={paragraphRef} className="mt-6 md:mt-8 max-w-[55ch] text-base md:text-lg leading-relaxed text-foreground/85 font-default transition-all duration-1000 delay-150 ease-out" style={{
          opacity: paragraphVisible ? 1 : 0,
          transform: paragraphVisible ? "translateY(0)" : "translateY(30px)"
        }}>
            Tell us which year group and exam board you teach. We&apos;ll set up a short pilot and show you what Setura finds in your students&apos; working. We usually reply within two working days.
          </p>

          <div ref={ctaRef} className="mt-10 md:mt-12 flex flex-col items-center justify-center transition-all duration-1000 delay-300 ease-out" style={{
          opacity: ctaVisible ? 1 : 0,
          transform: ctaVisible ? "translateY(0)" : "translateY(20px)"
        }}>
            <Button asChild size="lg" className="h-14 px-8 text-sm font-mono uppercase tracking-widest rounded-lg shadow-md bg-primary text-primary-foreground hover:bg-primary/90 hover:-translate-y-0.5 transition-transform duration-300">
              <Link to="/PilotPage">
                Book a pilot call
                <ArrowUpRight className="ml-1 size-4" />
              </Link>
            </Button>

            <p className="mt-4 text-xs md:text-sm text-muted-foreground font-default text-center transition-all duration-1000 ease-out" style={{
            opacity: ctaVisible ? 1 : 0,
            transform: ctaVisible ? "translateY(0)" : "translateY(10px)",
            transitionDelay: "450ms"
          }}>No commitment: just a conversation.</p>
          </div>
        </div>
      </div>

      {/* Bottom border line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-border/60" />
    </section>;
}